"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Button_1 = require("../button/Button");
const merlin_icon_1 = require("@travelnest/merlin.icon");
const StyledIcon = styled_1.default.div `
	width: 25px;
	height: 25px;
	position: relative;
	${({ iconPosition }) => iconPosition === 'after' ? 'margin-left: -5px; left: 5px;' : 'margin-right: 5px; left: -5px;'}
`;
const StyledButtonContent = styled_1.default.div `
	display: flex;
	align-items: center;
`;
const IconButton = (props) => {
    const { children, iconPosition = 'before' } = props, attrs = __rest(props, ["children", "iconPosition"]);
    return React.createElement(Button_1.Button, Object.assign({}, attrs),
        React.createElement(StyledButtonContent, null,
            iconPosition === 'after' && children,
            React.createElement(StyledIcon, { iconPosition: iconPosition },
                React.createElement(merlin_icon_1.Icon, Object.assign({}, attrs))),
            iconPosition === 'before' && children));
};
exports.default = IconButton;
//# sourceMappingURL=IconButton.js.map